export enum SYNC_REQUEST_TYPE {
    REFRESH_ALL,
    REFRESH_NOTIFICATIONS,
    REFRESH_WHATSNEW,
    REFRESH_BOOTSTOCK,
    FLUSH_ONLY,
    FLUSH_AND_REFRESH_NOTIFICATIONS_AND_BOOTSTOCK,
    FLUSH_AND_REFRESH_ALL,
}
